export default "__VITE_ASSET__f1eojPOB__"